import { render, staticRenderFns } from "./PaukTickets.vue?vue&type=template&id=b0a4e8e6"
import script from "./PaukTickets.vue?vue&type=script&lang=js"
export * from "./PaukTickets.vue?vue&type=script&lang=js"
import style0 from "./PaukTickets.vue?vue&type=style&index=0&id=b0a4e8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports